module.exports = __webpack_public_path__ + "static/img/3-5.77472003.png";